/* ==== MM / Présentation vidéo — JS =======================================
   - Carte vidéo → visionneuse plein écran (adaptée de la visionneuse Stories
     du Slider Vidéo : overlay + carte 9:16, Esc / overlay pour fermer, tap
     sur la vidéo = play/pause) mais MONO-vidéo : barre de progression pilotée
     par timeupdate (cliquable pour se déplacer), temps écoulé / total.
     La position de lecture survit à la fermeture (vidéo longue : on reprend
     où on s'était arrêté).
   - Marquee piloté PAR LE SCROLL avec lissage lerp, à toutes les tailles : le
     scroll fixe une CIBLE, un rAF fait glisser l'offset vers elle (inertie
     douce) puis s'endort une fois posé. Pas de défilement automatique.
     Boucle sans couture par clonage du set (même protocole data-mm-marquee
     que le hero Binikit).                                                 */
(function () {
  'use strict';

  /* Icônes du SET, en miroir exact du rendu de mm-icon (standard §2/§3 —
     jamais redessinées) : tracés copiés depuis assets/Icons/icon-play.svg,
     icon-pause.svg et icon-close.svg. icon_class 'icon-play'/'icon-pause' :
     le CSS d'états du bouton play/pause s'appuie sur ces classes. */
  var SVG_PLAY = '<svg class="mm-flex icon-play" style="width: 16px; height: 16px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5.45294 4.26845C5.25296 4.14994 5 4.29408 5 4.52653V11.4735C5 11.706 5.25296 11.8501 5.45294 11.7316L11.3145 8.25814C11.5105 8.14194 11.5105 7.85814 11.3145 7.74194L5.45294 4.26845Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_PAUSE = '<svg class="mm-flex icon-pause" style="width: 16px; height: 16px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="4.5" y="4" width="2" height="8" rx="0.5" fill="currentColor" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="9.5" y="4" width="2" height="8" rx="0.5" fill="currentColor" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_CLOSE = '<svg style="width: 14px; height: 14px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.5 4.5L4.5 11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M4.5 4.5L11.5 11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';

  function formatTime(seconds) {
    seconds = Math.max(0, Math.floor(seconds || 0));
    return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
  }

  /* ------------------------------------------------ visionneuse ------- */
  function createViewer(card) {
    var src = card.getAttribute('data-video');
    var youtubeId = card.getAttribute('data-youtube');
    var posterImg = card.querySelector(':scope > img');

    var strings = window.accessibilityStrings || {};
    var viewer = document.createElement('div');
    viewer.className = 'mm-vdstory';
    if (youtubeId) {
      viewer.classList.add('mm-vdstory--youtube');
      if (card.getAttribute('data-youtube-format') === 'horizontal') viewer.classList.add('mm-vdstory--landscape');
    }
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', card.getAttribute('aria-label') || strings.video || '');
    viewer.innerHTML =
      '<div class="mm-vdstory__overlay"></div>' +
      '<button type="button" class="mm-vdstory__close" aria-label="' + (strings.close || '') + '">' + SVG_CLOSE + '</button>' +
      '<div class="mm-vdstory__card">' +
      '  <div class="mm-vdstory__media"></div>' +
      '  <div class="mm-vdstory__controls">' +
      '    <button type="button" class="mm-vdstory__playpause" aria-label="' + (strings.videoPlayPause || '') + '">' + SVG_PAUSE + SVG_PLAY + '</button>' +
      '    <div class="mm-vdstory__seek"><div class="mm-vdstory__seek-bar"><span></span></div></div>' +
      '    <span class="mm-vdstory__time">0:00</span>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(viewer);

    var media = viewer.querySelector('.mm-vdstory__media');
    var seek = viewer.querySelector('.mm-vdstory__seek');
    var seekFill = viewer.querySelector('.mm-vdstory__seek-bar span');
    var timeEl = viewer.querySelector('.mm-vdstory__time');
    var video = null;
    var iframe = null;

    /* YouTube : iframe créée au premier open (autoplay), puis pilotée par
       l'API postMessage (enablejsapi) → pause à la fermeture, reprise à la
       réouverture, position de lecture conservée comme pour la vidéo native */
    function youtubeCommand(func) {
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
      }
    }
    function ensureIframe() {
      if (iframe) { youtubeCommand('playVideo'); return; }
      iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(youtubeId) +
        '?autoplay=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1';
      iframe.title = card.getAttribute('aria-label') || strings.video || '';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      media.appendChild(iframe);
    }

    /* la vidéo n'est créée qu'au premier open, puis réutilisée (la position
       de lecture est conservée entre deux ouvertures) */
    function ensureVideo() {
      if (video) return video;
      video = document.createElement('video');
      video.src = src;
      if (posterImg) video.poster = posterImg.currentSrc || posterImg.src;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';

      video.addEventListener('loadedmetadata', update);
      video.addEventListener('timeupdate', update);
      video.addEventListener('play', function () { viewer.classList.remove('is-paused'); });
      video.addEventListener('pause', function () { viewer.classList.add('is-paused'); });
      /* fin de lecture : état pause, la prochaine lecture repart du début */
      video.addEventListener('ended', function () { video.currentTime = 0; });

      media.appendChild(video);
      return video;
    }

    function update() {
      if (!video || !video.duration) return;
      seekFill.style.transform = 'scaleX(' + (video.currentTime / video.duration) + ')';
      timeEl.textContent = formatTime(video.currentTime) + ' / ' + formatTime(video.duration);
    }

    function open() {
      viewer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (youtubeId) { ensureIframe(); return; }
      var p = ensureVideo().play();
      if (p && p.catch) p.catch(function () {});
    }
    function close() {
      viewer.classList.remove('is-open');
      if (video) video.pause();
      youtubeCommand('pauseVideo');
      document.documentElement.style.overflow = '';
    }
    function togglePause() {
      if (!video) return;
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      else video.pause();
    }

    viewer.querySelector('.mm-vdstory__overlay').addEventListener('click', close);
    viewer.querySelector('.mm-vdstory__close').addEventListener('click', close);
    viewer.querySelector('.mm-vdstory__playpause').addEventListener('click', togglePause);
    /* tap sur la vidéo = play/pause, comme sur les stories */
    media.addEventListener('click', togglePause);

    /* barre cliquable : proportion du clic → position de lecture */
    seek.addEventListener('click', function (e) {
      if (!video || !video.duration) return;
      var rect = seek.getBoundingClientRect();
      var ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
      video.currentTime = ratio * video.duration;
      update();
    });

    document.addEventListener('keydown', function (e) {
      if (!viewer.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === ' ') { e.preventDefault(); togglePause(); }
    });

    return { open: open };
  }

  /* ------------------------------------------- marquee scroll + lerp -- */
  function initMarquee(marquee) {
    var track = marquee.querySelector('[data-mm-marquee-track]');
    var set = marquee.querySelector('[data-mm-marquee-set]');
    if (!track || !set) return;

    var SPEED = 0.5;   /* px de défilement par px de scroll */
    var EASE = 0.09;   /* force du lerp : plus petit = plus d'inertie */
    var setWidth = 0;
    var target = 0, current = 0, raf = null;

    /* Duplique le set jusqu'à couvrir 2× la largeur visible → boucle sans couture */
    function build() {
      track.querySelectorAll('[data-mm-marquee-clone]').forEach(function (c) { c.remove(); });
      setWidth = set.getBoundingClientRect().width;
      if (!setWidth) return;
      var need = Math.ceil((marquee.offsetWidth * 2 + setWidth) / setWidth);
      for (var i = 0; i < need; i++) {
        var clone = set.cloneNode(true);
        clone.setAttribute('data-mm-marquee-clone', '');
        clone.removeAttribute('data-mm-marquee-set');
        track.appendChild(clone);
      }
    }

    function render() {
      if (!setWidth) return;
      var x = -(((current % setWidth) + setWidth) % setWidth);
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    /* le rAF ne tourne que le temps de rejoindre la cible, puis s'endort */
    function tick() {
      current += (target - current) * EASE;
      if (Math.abs(target - current) < 0.1) {
        current = target;
        render();
        raf = null;
        return;
      }
      render();
      raf = window.requestAnimationFrame(tick);
    }
    function kick() {
      if (!raf) raf = window.requestAnimationFrame(tick);
    }

    function onScroll() {
      target = (window.pageYOffset || document.documentElement.scrollTop || 0) * SPEED;
      kick();
    }

    build();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { build(); render(); });

    /* Confort preview UNIQUEMENT : si la page n'est pas scrollable, la
       molette au-dessus du bandeau le fait défiler (avec le même lerp).
       En prod c'est le scroll de page qui pilote. */
    marquee.addEventListener('wheel', function (e) {
      var scrollable = (document.documentElement.scrollHeight - window.innerHeight) > 4;
      if (scrollable || !setWidth) return;
      target += e.deltaY * SPEED;
      kick();
    }, { passive: true });
  }

  /* --------------------------- bandeau logos presse : défilement infini -- */
  /* Mobile uniquement : la piste (CSS, translate -50%) doit contenir assez de
     copies du set pour couvrir la card à chaque instant, sinon le retour de
     boucle laisse un vide. Le nombre de copies par moitié et la durée du
     défilement (16s par set) sont recalculés à chaque changement de taille. */
  function initPressLoop(root) {
    var logos = root.querySelector('.mm-vdetails__press-logos');
    var strip = logos && logos.querySelector('.mm-vdetails__press-strip');
    var set = strip && strip.querySelector('.mm-vdetails__press-set:not(.mm-vdetails__press-set--clone)');
    var template = strip && strip.querySelector('.mm-vdetails__press-set--clone');
    if (!set || !template) return;

    var SECONDS_PER_SET = 16;
    var mobile = window.matchMedia('(max-width: 749px)');
    template.remove();

    function build() {
      strip.querySelectorAll('[data-mm-press-clone]').forEach(function (c) { c.remove(); });
      strip.style.animationDuration = '';
      if (!mobile.matches) return;
      var setWidth = set.getBoundingClientRect().width;
      if (!setWidth) return;
      /* une moitié de piste = `half` sets, couvrant au moins la largeur de la card */
      var half = Math.max(1, Math.ceil(logos.clientWidth / setWidth));
      for (var i = 1; i < half * 2; i++) {
        var copy = template.cloneNode(true);
        copy.setAttribute('data-mm-press-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        strip.appendChild(copy);
      }
      /* le set (et sa copie) de la 2e moitié est identique : vitesse constante */
      strip.style.animationDuration = (SECONDS_PER_SET * half) + 's';
    }

    build();
    window.addEventListener('resize', build);
  }

  /* ------------------------------------------------ init -------------- */
  function initVDetails(root) {
    /* les previews ré-exécutent les scripts : init une seule fois par racine */
    if (root.hasAttribute('data-mm-vdetails-ready')) return;
    root.setAttribute('data-mm-vdetails-ready', '');

    var card = root.querySelector('.mm-vdetails__card');
    if (card && (card.getAttribute('data-video') || card.getAttribute('data-youtube'))) {
      var viewer = createViewer(card);
      card.addEventListener('click', function () { viewer.open(); });
    }

    root.querySelectorAll('[data-mm-marquee]').forEach(initMarquee);
    initPressLoop(root);
  }

  document.querySelectorAll('.mm-vdetails').forEach(initVDetails);
})();
